import React from 'react';
import { isProjectReadOnly } from '../../../common/utils/api_utils';

const PHIAuditHeader = ({
  hasFindings,
  lastAuditedAt,
  loading,
  hasAudit,
  onRunAudit,
  projectId,
}) => {
  const isReadOnly = isProjectReadOnly(projectId);
  return (
    <div className="d-flex align-items-center justify-content-between p-3 mb-4 rounded">
      <div className="d-flex align-items-center">
        <div
          className="d-flex align-items-center justify-content-center rounded-circle mr-3"
          style={{
            width: '48px',
            height: '48px',
            backgroundColor: hasFindings ? '#fde8e8' : '#e3f6e9',
          }}
        >
          <i
            className={`wb ${hasFindings ? 'webconnect-exclamation' : 'webconnect-check'}`}
            style={{
              fontSize: '22px',
              color: hasFindings ? '#dc3545' : '#28a745',
            }}
          />
        </div>

        <div>
          <h5 className="fw-semibold mb-1">PHI Security Audit</h5>

          <div className="text-muted small">Project-level PHI security assessment</div>

          {lastAuditedAt && <div className="text-muted small mt-1">Audited {lastAuditedAt}</div>}
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary px-4"
        onClick={isReadOnly ? undefined : onRunAudit}
        disabled={loading || isReadOnly}
        title={isReadOnly && 'Read-Only Mode'}
      >
        {loading ? (
          <>
            <span
              className="me-2"
              style={{
                display: 'inline-block',
                width: '14px',
                height: '14px',
                border: '2px solid rgba(255, 255, 255, 0.4)',
                borderTopColor: '#fff',
                borderRadius: '50%',
                animation: 'phiAuditSpin 0.8s linear infinite',
                verticalAlign: '-2px',
              }}
            />{' '}
            &nbsp; Running Audit
          </>
        ) : (
          <>
            <i className="wb webconnect-shield-check mr-2" />

            {hasAudit ? 'Run Audit Again' : 'Run PHI Audit'}
          </>
        )}
      </button>
    </div>
  );
};

export default PHIAuditHeader;
